'use strict';
import {module} from '../app';

module.service('enums', [function () {
  let self = this;

  self.statuses = ['New', 'SurveyStarted', 'SurveyFinished', 'ExamWaiting', 'ExamInProgress', 'ExamPaused', 'ExamStopped', 'ExamIncomplete', 'Finished', 'UltrasoundRequested', 'RISWaiting'];

  self.examTypes = ['Mammography', 'Ultrasound', 'Tomosynthesis', 'Ductography', 'Breast MRI', 'Bone Densitometry', 'Lung', 'Other'];

  self.examShortCodeTypes = ['Mammo', 'US', 'Tomo', 'Duct.', 'MRI', 'Dexa', 'Lung', 'Other'];
  
  self.dStatusType = [
    { code: 'W', label: 'Worklist Hold' },
    { code: 'WH', label: 'Worklist Hold' },
    { code: 'D', label: 'Dictated' },
    { code: 'DH', label: 'Dictated Hold' },
    { code: 'T', label: 'Transcribed' },
    { code: 'TH', label: 'Trans Hold' },
    { code: 'B', label: 'Trans Review' },
    { code: 'BH', label: 'Trans Review' },
    { code: 'P', label: 'Approved' },
    { code: 'OH', label: 'PowerScribe Hold' },
    { code: 'S', label: 'Signed' },
    { code: 'SH', label: 'Rad Hold' },
    { code: '2', label: 'Second Reader' },
    { code: '2H', label: 'Hold for 2R' },
    { code: 'E', label: 'Error' },
    { code: 'EH', label: 'Resident Hold' },
    { code: 'H', label: 'Resident' },
    { code: 'R', label: 'Released' },
    { code: 'AD', label: '+Dictated' },
    { code: 'ADH', label: '+Dictated Hold' },
    { code: 'AT', label: '+Transcribed' },
    { code: 'ATH', label: '+Trans Hold' },
    { code: 'AS', label: '+Signed' },
    { code: 'ARH', label: '+Rad Hold' },
    { code: 'AR', label: '+Released' },
    { code: 'X', label: 'Extracted' },
    { code: '*', label: 'Never-opened' },
    { code: 'F', label: 'Final' },
    { code: 'I', label: 'Import' },
    { code : 'H', label: 'Hold' },
  ];

  self.statusesWithReport = [
    { code: 'R', label: 'Released' },
    { code: 'X', label: 'Extracted' },
    { code: 'AR', label: '+Released' },
  ];

  self.biRads = [
    { code: 'A', label: '0' },
    { code: 'N', label: '1' },
    { code: 'B', label: '2' },
    { code: 'P', label: '3' },
    { code: 'S', label: '4' },
    { code: 'M', label: '5' },
    { code: 'K', label: '6' }
  ];

  self.visitTypes = [
    { code: "D", label: "Diagnostic" },
    { code: "A", label: "Additional evaluation" },
    {
      code: "S",
      label: "Screening",
    },
    {
      code: "B",
      label: "Biopsy",
    },
    {
      code: "O",
      label: "Other",
    },
  ];

  self.procTypes = [
    { Key: 'M', Value: 'Mammography' },
    { Key: 'U', Value: 'Ultrasound' },
    { Key: 'D', Value: 'Ductography' },
    { Key: 'R', Value: 'Breast MRI' },
    { Key: 'X', Value: 'Bone Densitometry' },
    { Key: 'MU', Value: 'Mammo/US' },
    { Key: 'O', Value: 'Other' }
  ];

  self.viewsTypes = [
    { Key: 'N', Value: 'Standard' },
    { Key: 'S', Value: 'Spot' },
    { Key: 'M', Value: 'Mag' },
    { Key: 'C', Value: 'Spot Mag' },
    { Key: 'I', Value: 'ID' },
    { Key: 'T', Value: 'TOMO' },
    { Key: 'X', Value: 'Spot TOMO' }
  ];
  self.allStatusGroups = [{
    name: 'Patient Survey',
    statuses: ['New', 'SurveyStarted', 'SurveyFinished'],
    key: 'New',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Waiting for Exam',
    statuses: ['ExamWaiting'],
    key: 'ExamWaiting',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Performing Exam',
    statuses: ['ExamInProgress', 'ExamPaused', 'ExamIncomplete', 'Finished'],
    key: 'ExamInProgress',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Exam Ended',
    statuses: ['ExamStopped'],
    key: 'ExamStopped',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Ultrasound Request',
    statuses: ['UltrasoundRequested', 'RISWaiting'],
    key: 'UltrasoundRequested',
    onlyForRoles: ['UltrasoundTechnologist']
  }];

  self.worklistStatuses = {
    New: 'New',
    SurveyStarted: 'SurveyStarted',
    SurveyFinished: 'SurveyFinished',
    ExamWaiting: 'ExamWaiting',
    ExamInProgress: 'ExamInProgress',
    ExamPaused: 'ExamPaused',
    ExamStopped: 'ExamStopped',
    ExamIncomplete: 'ExamIncomplete',
    Finished: 'Finished',
    UltrasoundRequested: 'UltrasoundRequested',
    RISWaiting: 'RISWaiting',
    TakeExam: 'TakeExam',
    ReviewComplete: 'ReviewComplete'
  };

  self.FUReasons = {
    Refused: 'R',
    FollowedElsewhere: 'E',
    LostContact: 'L',
    PatientDeceased: 'D',
    Internal: 'I',
    ResolvedAfterLastLetter : '4'
  };

  self.worklistAdditionalInfos = {
    ReleasePatient: 'ReleasePatient',
    AdditionalImaging: 'AdditionalImaging',
    UltrasoundRequested: 'UltrasoundRequested',
    Other: 'Other'
  };

}]);



// WEBPACK FOOTER //
// ./src/scripts/services/enums.js